import Toast from "@components/Toast";
import {readLinkWhitelist} from "@server";

/**
 *  清理HTTP域名白名单，去掉前缀点和转换格式
 */
const cleanWhiteHttpList = (whiteHttpList: string[]) => {
  const cleaned = whiteHttpList
    .filter(domain => typeof domain === 'string')
    .map(domain => domain.startsWith('.') ? domain.slice(1) : domain);
  return cleaned;
}

/**
 * 获取链接白名单
 */
export const getUrlWhitelist = async () => {
  const res = await readLinkWhitelist();

  let whiteList = [];
  let whiteHttpList = [];
  if (res?.code === 0) {
    whiteList = res?.data?.hostScheme || [];
    whiteHttpList = cleanWhiteHttpList(
      res?.data?.host?.concat(res?.data?.hostBrowser) || []
    );
  }
  return { whiteList, whiteHttpList };
}

/**
 * 清理HTTP链接，支持白名单域名检查
 */
export const cleanHttpLinks = (html: string, whiteHttpList: string[]) => {
    // 预处理白名单，全部转小写、去掉前后空格
    const domains = whiteHttpList.map(domain => domain.replace(/^\.+/, '').trim().toLowerCase());
    return html.replace(/<a\s+[^>]*href="(https?:\/\/[^"]+)"[^>]*>(.*?)<\/a>/gi, (match, href, inner) => {
        try {
            const url = new URL(href);
            const host = url.host.toLowerCase();
            // 域名白名单支持主域名和二级域名
            const isWhite = domains.some(domain =>
                host === domain ||
                host.endsWith('.' + domain)
            );
            if (isWhite) {
                return match; // 保留原a标签
            } else {
                // 不在白名单，去掉整个a标签，只保留内容
                return inner;
            }
        } catch {
            // 解析失败也去掉a标签
            return inner;
        }
    });
}

/**
 * 清理自定义链接（deeplink），支持白名单检查
 */
export const cleanCustomLinks = (html: string, whitelist: string[]) => {
    return html.replace(/<a\s+[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi, (match, href, inner) => {
        // 1. https://后面是deeplink（如vivo://等）
        const httpsDeeplink = href.match(/^https:\/\/([a-z0-9\.\-\+]+:\/\/.+)/i);
        if (httpsDeeplink) {
            const deeplink = httpsDeeplink[1];
            const isWhite = whitelist.some(scheme => deeplink.startsWith(scheme));
            if (isWhite) {
                return match; // 白名单，保留原样
            } else {
                // 非白名单deeplink，去掉整个a标签，只保留内容
                return inner;
            }
        }

        // 2. 直接是deeplink协议（非http/https），判断是否白名单
        const isDeeplink = /^[a-z0-9\.\-\+]+:\/\//i.test(href) && !/^https?:\/\//i.test(href);
        if (isDeeplink) {
            const isWhite = whitelist.some(scheme => href.startsWith(scheme));
            if (isWhite) {
                return match;
            } else {
                return inner;
            }
        }

        // 3. 其它（普通http/https等）全部保留原样
        return match;
    });
}
